import C from './constants';

export const setActiveProfileElements = (active_profile_elements) => ({
  type: C.SET_ACTIVE_PROFILE_ELEMENTS,
  payload: active_profile_elements
})

export const setAddress = (address) => ({
  type: C.SET_ADDRESS,
  payload: address
})

export const setContent = (content) => ({
  type: C.SET_CONTENT,
  payload: content
})

export const setEthnicityOptions = (ethnicity_options) => ({
  type: C.SET_ETHNICITY_OPTIONS,
  payload: ethnicity_options
})

export const setLanguageOptions = (language_options) => ({
  type: C.SET_LANGUAGE_OPTIONS,
  payload: language_options
})

export const setNextPage = (next_page) => ({
  type: C.SET_NEXT_PAGE,
  payload: next_page
})

export const setPage = (page) => ({
  type: C.SET_PAGE,
  payload: page
})

export const setPages = (pages) => ({
  type: C.SET_PAGES,
  payload: pages
})

export const setPreviousPage = (previous_page) => ({
  type: C.SET_PREVIOUS_PAGE,
  payload: previous_page
})

export const setProfileElements = (profile_elements) => ({
  type: C.SET_PROFILE_ELEMENTS,
  payload: profile_elements
})

export const setRequiredFields = (required_fields) => ({
  type: C.SET_REQUIRED_FIELDS,
  payload: required_fields
})

export const setTerritory = (territory) => ({
  type: C.SET_TERRITORY,
  payload: territory
})

export const setMarket = (market) => ({
  type: C.SET_MARKET,
  payload: market
})

export const setRecaptchaSiteId = (site_id) =>
  ({
    type: C.SET_RECAPTCHA_SITE_ID,
    payload: site_id
  });

export const setVaccinationMandatory = (vaccination_mandatory) =>
  ({
    type: C.SET_VACCINATION_MANDATORY,
    payload: vaccination_mandatory 
  });

export const setAuthenticatedUser = (authenticatedUser) =>
  ({
    type: C.SET_AUTHENTICATED_USER,
    payload: authenticatedUser
  });
